import React from "react";
import { I, T } from "services/lang/LanguageService";
import { DweenCalendarEnum } from "utils/enums";
import { toZonedDateTime } from "utils/time-utils";
import { get445MonthInfo } from "utils/four-four-five-calendar-utils";
import { Instant } from "@js-joda/core";
import { useCompanyTimezone } from "hooks/useTimezone";
import { AggregationPeriod, DataDisplayType, ValueChangeIndicatorProps } from "./ValueChangeIndicatorTypes";
import { getTextColor } from "../charts/utils";
import {
  getFromDate,
  getPeriodLabel,
  getPeriodLabelIn445Calendar,
  getTitleClassName,
} from "./ValueChangeIndicatorUtils";

const TitleAndSubtitleTemplate = (
  props: ValueChangeIndicatorProps & {
    refTime: Instant;
    calculateFromStartOfTheProject: boolean;
  }
) => {
  const companyTz = useCompanyTimezone();

  const getUpToPeriodLabel = (upToUnit: AggregationPeriod) => {
    if (props.calendarType === DweenCalendarEnum.CALENDAR_445) {
      const refTimeIn445 = get445MonthInfo(props.refTime, companyTz);
      const endOf445PeriodInstant = refTimeIn445.endDate
        .atStartOfDay(companyTz)
        .plusDays(1)
        .minusNanos(1)
        .toInstant();
      return getPeriodLabelIn445Calendar(upToUnit, endOf445PeriodInstant, companyTz, false);
    }

    return getPeriodLabel(upToUnit, props.refTime, companyTz);
  };

  const isStartOfTheProjectValid = () => {
    if (props.calculateFromStartOfTheProject && props.startOfTheProject) {
      const startYear = toZonedDateTime(props.startOfTheProject, companyTz).year();
      const refYear = props.refTime.atZone(companyTz).year();
      return refYear - startYear <= 0;
    }
    return false;
  };

  const fromToTemplate = (upToUnit: AggregationPeriod) => {
    return (
      <div>
        {props.startOfTheProject && isStartOfTheProjectValid() ? (
          `${T("word.from")} ${props.dataDisplayType === DataDisplayType.WEEK_YEAR_COMPARISON ? getPeriodLabel(upToUnit, props.startOfTheProject, companyTz) : getFromDate(props.startOfTheProject, companyTz)},                  
                  ${T("label.up-to").toLocaleLowerCase()}
        ${getUpToPeriodLabel(upToUnit)}`
        ) : (
          <>
            {T("label.up-to")} {getUpToPeriodLabel(upToUnit)}
          </>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-column title-container">
      <div
        style={{ color: getTextColor(props.theme) }}
        className={getTitleClassName(props.dataDisplayType, props.displayInline)}
      >
        <div>{I(props.title ?? "")}</div>
      </div>
      <div style={{ color: getTextColor(props.theme) }} className="subtitle font-medium">
        {(props.dataDisplayType === DataDisplayType.HORIZONTAL_BAR_CHART ||
          (props.dataDisplayType === DataDisplayType.WEEK_YEAR_COMPARISON && props.useHorizontalBarChart)) &&
        props.upToUnit ? (
          fromToTemplate(props.upToUnit)
        ) : (
          <div>{I(props.subtitle ?? "")}</div>
        )}
      </div>
    </div>
  );
};
export default TitleAndSubtitleTemplate;
